import React, { useState } from "react";
import {
  IconButton,
  useTheme,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import ConfirmationDialog from "../../../../../components/ConfirmationDialog";
import EditFileDialog from "../EditFileDialog";
import {
  MoreVertRounded,
  EditRounded,
  DeleteRounded,
  DownloadRounded,
} from "@mui/icons-material";
import { notSupportedBrowserFiles } from "./GridView";
import {
  CLICK_ACTION_MENU_ON_FILE_EXPLORER,
  DOWNLOAD_FILE,
} from "../../../../../utils/posthogEvents";
import { usePostHog } from "posthog-js/react";

function FileActionsMenu({
  file,
  edge = "end",
  handleDeleteFile,
  handleUpdateFile,
  handleOpenFileInNewTab,
}) {
  const { id, file_type } = file;
  const theme = useTheme();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const posthog = usePostHog();
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    posthog.capture(CLICK_ACTION_MENU_ON_FILE_EXPLORER);
  };

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleDownloadFile = async () => {
    try {
      const response = await fetch(file.file_url);
      if (!response.ok) return;
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.name || "file";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
      posthog.capture(DOWNLOAD_FILE);
      handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <IconButton
        component="div"
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={handleClick}
        size="small"
        edge="end"
        sx={edge === "end" ? { marginRight: -1.5, marginTop: -0.5 } : {}}>
        <MoreVertRounded fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleClose(e);
        }}
        autoFocus={false}
        disableAutoFocusItem
        slotProps={{ paper: { sx: { borderRadius: 2 } } }}>
        <MenuItem
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            handleDownloadFile();
          }}>
          <ListItemIcon>
            <DownloadRounded />
          </ListItemIcon>
          <Typography>Download File</Typography>
        </MenuItem>
        <MenuItem
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            setIsEditDialogOpen(true);
          }}>
          <ListItemIcon>
            <EditRounded />
          </ListItemIcon>
          <Typography>Rename File</Typography>
        </MenuItem>
        <MenuItem
          sx={{ color: theme.palette.error.main }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteDialogOpen(true);
          }}>
          <ListItemIcon>
            <DeleteRounded sx={{ color: theme.palette.error.main }} />
          </ListItemIcon>
          <Typography>Delete File</Typography>
        </MenuItem>
      </Menu>
      {isDeleteDialogOpen && (
        <ConfirmationDialog
          title={"Delete File"}
          content={`Do you really want to delete this file? This will permanently delete it from the account.`}
          noLabel={"cancel"}
          yesLabel={"yes, delete"}
          onNo={() => setIsDeleteDialogOpen(false)}
          onYes={() => handleDeleteFile(id)}
          isDelete={true}
        />
      )}
      {isEditDialogOpen && (
        <EditFileDialog
          file={file}
          handleUpdateFile={handleUpdateFile}
          onClose={() => setIsEditDialogOpen(false)}
        />
      )}
    </>
  );
}

export default FileActionsMenu;
